export function LoadingState() {
  return (
    <div className="loading-layout" aria-label="Cargando tablero">
      <div className="skeleton skeleton-title" />
      <div className="skeleton-grid">
        {Array.from({ length: 4 }).map((_, index) => (
          <div className="skeleton skeleton-card" key={index} />
        ))}
      </div>
      <div className="skeleton-body">
        <div className="skeleton skeleton-panel" />
        <div className="skeleton skeleton-panel wide" />
      </div>
    </div>
  );
}
